import React from 'react';
import classnames from 'classnames';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import Label from 'components/form/Label/Label';
import './NegativeMarksList.scss';

const NegativeMarksList = props => {
  const { paymentHistory, className } = props;
  const negativeMarks = [
    {
      name: 'Late Payments',
      value: paymentHistory.latePaymentAccounts,
    },
    {
      name: 'Collections',
      value: paymentHistory.collections,
    },
    {
      name: 'Foreclosures',
      value: paymentHistory.foreclosures,
    },
    {
      name: 'Bankruptcies',
      value: paymentHistory.bankruptcies,
    },
    {
      name: 'Charge-Offs',
      value: paymentHistory.chargeOffs,
    },
  ];

  const getDotClass = value => {
    if (value === 0) {
      return 'bgGreen100';
    } else if (value > 0 && value < 3) {
      return 'bgYellow100';
    } else {
      return 'bgRed100';
    }
  };

  const containerClassname = classnames("negativeMarksListContainer", className)

  return (
    <div className={containerClassname}>
      {negativeMarks.map((item, index) => {
        return (
          <FlexContainer
            className={`${
              index !== 0 ? 'margT16' : ''
            } items-align-center justify-between`}
          >
            <div className={`dot margR8 ${getDotClass(item.value)}`} />
            <Label type="Body1" className="t-text-12">{item.name}</Label>
            <div className="dottedLine margLR16" />
            <Label type="subTitle1" className="t-text-12">{item.value}</Label>
          </FlexContainer>
        );
      })}
    </div>
  );
};

export default NegativeMarksList;
